/** Display helpers aligned with CMS users list (UsersContent / TalentDetails). */

export function profileDisplayInitial(profile) {
  if (!profile) return "?";
  const fn = profile.first_name && String(profile.first_name).trim();
  const ln = profile.last_name && String(profile.last_name).trim();
  const em = profile.email && String(profile.email).trim();
  const name = fn || ln || em || "?";
  return name.charAt(0).toUpperCase();
}

export function hslBackgroundForProfileId(id) {
  const n = Number(id) || 0;
  const h = (n * 47) % 360;
  return `hsl(${h}, 55%, 42%)`;
}

/** Non-empty image URL only (no stock gender avatars — letter fallback handles empty). */
export function profileHasPhoto(profile) {
  return !!(profile && profile.image && String(profile.image).trim());
}

function _fixDecodedOAuthSlashes(inner) {
  if (inner.startsWith("https:/") && !inner.startsWith("https://")) {
    return "https://" + inner.slice(7);
  }
  if (inner.startsWith("http:/") && !inner.startsWith("http://")) {
    return "http://" + inner.slice(6);
  }
  return inner;
}

/**
 * Recover a real https:// URL when the API stored OAuth avatars as:
 * - .../api/uploaded_media/https%3A/lh3...
 * - raw https%3A/lh3... (no scheme, percent-encoded)
 */
export function normalizeProfileImageUrl(url) {
  if (!url || typeof url !== "string") return url;
  const s = url.trim();

  const mediaMarker = "/api/uploaded_media/";
  const mediaIdx = s.indexOf(mediaMarker);
  if (mediaIdx !== -1) {
    const tail = s.slice(mediaIdx + mediaMarker.length).split(/[?#]/)[0];
    if (/^https%3A|^http%3A/i.test(tail)) {
      try {
        let inner = _fixDecodedOAuthSlashes(decodeURIComponent(tail));
        if (/^https?:\/\//i.test(inner)) return inner;
      } catch (e) {
        /* fall through */
      }
    }
  }

  // Whole value is a percent-encoded https URL (common on profile.image from API)
  const head = s.split(/[?#]/)[0];
  if (/^https%3A|^http%3A/i.test(head)) {
    try {
      let inner = _fixDecodedOAuthSlashes(decodeURIComponent(s));
      if (/^https?:\/\//i.test(inner)) return inner;
    } catch (e) {
      return s;
    }
  }

  return s;
}
